import { Logger } from '@west-australian-newspapers/typescript-log'
import {
    BreachWallContentType,
    SubscriptionPackageOptions,
} from '../user-registration/breach/helpers/BreachWallTypes'
import { fetchSubscriptionOffers } from '../user-registration/breach/services/subscription-offer-api'
import { CampaignContentType } from '../subscribe-with-google/rrme-campaigns/types'
import {
    EVERYDAY_DIGITAL_52_WEEKS_RATE_CODE,
    EVERYDAY_DIGITAL_INCREASE,
    WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL,
    WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL_INCREASE,
    WEEKLY_DIGITAL_RATE_CODE_INCREASE,
    WE_PAPER_EVERYDAY_DIGITAL_RATE_CODE,
    WE_PAPER_EVERYDAY_DIGITAL_RATE_CODE_INCREASE,
} from '../user-registration/breach/constants'

export type OfferGroupType = 'breach' | 'campaigns'

export const offerGroups: OfferGroupType[] = ['breach', 'campaigns']

export type OfferGroupContentType = BreachWallContentType | CampaignContentType

const rrmeCampaignPackages: Record<
    CampaignContentType,
    SubscriptionPackageOptions[]
> = {
    'university-offer': [],
    'annual-package': [],
}

const rrmeBreachPackages: Record<
    BreachWallContentType,
    SubscriptionPackageOptions[]
> = {
    default: [
        {
            type: 'single-subscription',
            heading: 'Subscribe',
            price: '$8 per week',
            priceQualifier: 'Billed every four weeks.',
            packageType: 'digital',
            packageTheme: 'optimise-blue',
            packagePath: 'subscribe/new',
            cancellationMessage: 'Cancel anytime. Min cost $32.',
            googleSKU: 'SWGPD.1835-4609-9866-97776',
            weeklyPrice: EVERYDAY_DIGITAL_INCREASE,
            rateCode: WEEKLY_DIGITAL_RATE_CODE_INCREASE,
            buttonStyle: 'solid-blue',
            benefitOverride: [
                'Unlimited access to thewest.com.au',
                'Digital version of Today’s Paper',
                '19 WA regional papers',
                'Daily puzzles',
            ],
        },
        {
            type: 'single-subscription',
            heading: 'Everyday Digital + Weekend Papers',
            price: '$10 per week',
            priceQualifier: 'Billed every four weeks',
            packagePath: 'subscribenow/sat-sun+digital',
            rateCode: WE_PAPER_EVERYDAY_DIGITAL_RATE_CODE,
            weeklyPrice: WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL,
            cancellationMessage: 'Cancel anytime. Min cost $40.',
            packageType: 'digitalprint',
            packageTheme: 'optimise-blue',
            buttonStyle: 'solid-blue',
            benefitOverride: [
                'Weekend papers delivered',
                'Unlimited access to thewest.com.au',
                'Digital version of Today’s Paper',
                'Daily puzzles',
                '19 WA regional titles',
            ],
        },
    ],
    'default-price-increase': [
        {
            type: 'single-subscription',
            heading: 'Subscribe',
            price: '$8 per week',
            priceQualifier: 'Billed every four weeks.',
            packageType: 'digital',
            packageTheme: 'optimise-blue',
            packagePath: 'subscribe/new',
            cancellationMessage: 'Cancel anytime. Min cost $32.',
            googleSKU: 'SWGPD.1835-4609-9866-97776',
            weeklyPrice: EVERYDAY_DIGITAL_INCREASE,
            rateCode: WEEKLY_DIGITAL_RATE_CODE_INCREASE,
            buttonStyle: 'solid-blue',
            benefitOverride: [
                'Unlimited access to thewest.com.au',
                'Digital version of Today’s Paper',
                '19 WA regional papers',
                'Daily puzzles',
            ],
        },
        {
            type: 'single-subscription',
            heading: 'Everyday Digital + Weekend Papers',
            price: '$10 per week',
            priceQualifier: 'Billed every four weeks',
            packagePath: 'subscribenow/sat-sun+digital',
            rateCode: WE_PAPER_EVERYDAY_DIGITAL_RATE_CODE_INCREASE,
            weeklyPrice: WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL_INCREASE,
            cancellationMessage: 'Cancel anytime. Min cost $40.',
            packageType: 'digitalprint',
            packageTheme: 'optimise-blue',
            buttonStyle: 'solid-blue',
            benefitOverride: [
                'Weekend papers delivered',
                'Unlimited access to thewest.com.au',
                'Digital version of Today’s Paper',
                'Daily puzzles',
                '19 WA regional titles',
            ],
        },
    ],
    'default-annual-package': [
        {
            type: 'single-subscription',
            heading: 'Subscribe',
            price: '$8 per week',
            priceQualifier: 'Billed every four weeks.',
            packageType: 'digital',
            packageTheme: 'optimise-blue',
            packagePath: 'subscribe/new',
            cancellationMessage: 'Cancel anytime. Min cost $32.',
            googleSKU: 'SWGPD.1835-4609-9866-97776',
            weeklyPrice: EVERYDAY_DIGITAL_INCREASE,
            rateCode: WEEKLY_DIGITAL_RATE_CODE_INCREASE,
            buttonStyle: 'solid-blue',
            benefitOverride: [
                'Unlimited access to thewest.com.au',
                'Digital version of Today’s Paper',
                '19 WA regional papers',
                'Daily puzzles',
            ],
        },
        {
            type: 'single-subscription',
            heading: 'Subscribe',
            price: '$6 per week',
            priceQualifier: 'Billed annually.',
            ribbonTitle: 'SAVE 25%',
            ribbonOptions: 'bluePill',
            packageType: 'digital',
            packageTheme: 'optimise-blue',
            packagePath: 'subscribenow/annual-package',
            cancellationMessage: 'Cancel anytime. Min cost $312.',
            googleSKU: 'SWGPD.2349-0024-3173-99483',
            weeklyPrice: 6,
            rateCode: EVERYDAY_DIGITAL_52_WEEKS_RATE_CODE,
            buttonStyle: 'solid-blue',
            benefitOverride: [
                'Pay upfront and save',
                'Unlimited access to all articles',
                'Digital version of Today’s Paper',
                'Daily puzzles',
                '19 WA regional titles',
            ],
        },
    ],
    'digital-radio-and-papers': [
        {
            type: 'radio-list-subscriptions',
            heading: 'Everyday Digital',
            prices: [
                {
                    price: '$6 per week',
                    priceQualifier: 'Billed annually',
                    packagePath: 'subscribenow/annual-package',
                    rateCode: EVERYDAY_DIGITAL_52_WEEKS_RATE_CODE,
                    weeklyPrice: 6,
                    googleSKU: 'SWGPD.2349-0024-3173-99483',
                    ribbonTitle: 'SAVE 25%',
                    ribbonOptions: 'bluePill',
                    cancellationMessage: 'Cancel anytime. Min cost $312.',
                },
                {
                    price: '$8 per week',
                    priceQualifier: 'Billed every four weeks',
                    packagePath: 'subscribe/new',
                    rateCode: WEEKLY_DIGITAL_RATE_CODE_INCREASE,
                    weeklyPrice: EVERYDAY_DIGITAL_INCREASE,
                    googleSKU: 'SWGPD.1835-4609-9866-97776',
                    cancellationMessage: 'Cancel anytime. Min cost $32.',
                },
            ],
            packageType: 'digital',
            packageTheme: 'optimise-blue',
            buttonStyle: 'solid-blue',
            benefitOverride: [
                'Unlimited access to thewest.com.au',
                'Digital version of Today’s Paper',
                'Daily puzzles',
                '19 WA regional titles',
            ],
        },
        {
            type: 'radio-list-subscriptions',
            heading: 'Everyday Digital + Weekend Papers',
            prices: [
                {
                    price: '$10 per week',
                    priceQualifier: 'Billed every four weeks',
                    packagePath: 'subscribenow/sat-sun+digital',
                    rateCode: WE_PAPER_EVERYDAY_DIGITAL_RATE_CODE_INCREASE,
                    weeklyPrice: WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL_INCREASE,
                    cancellationMessage: 'Cancel anytime. Min cost $40.',
                },
            ],
            packageType: 'digitalprint',
            packageTheme: 'optimise-blue',
            buttonStyle: 'solid-blue',
            benefitOverride: [
                'Weekend papers delivered',
                'Unlimited access to thewest.com.au',
                'Digital version of Today’s Paper',
                'Daily puzzles',
                '19 WA regional titles',
            ],
        },
    ],
    sport: [],
    'black-friday': [
        {
            type: 'single-subscription',
            packagePath: 'offercheck/thewest?redirect=true&offerCode=BLKFRI1',
            heading: 'Everyday Digital',
            price: '$4/week',
            originalPrice: '$8 per week',
            billingCycle: 'Billed every week',
            priceQualifier: '*for 8 weeks',
            packageType: 'digital',
            ribbonTitle: 'On sale',
            ribbonOptions: 'cornerDesignTag',
            buttonStyle: 'solid-blue',
            offerCode: 'BLKFRI1',
            googleSKU: 'everyday_digital_50_off',
            cancellationMessage: 'Cancel anytime. Min cost $32.00',
            weeklyPrice: 8,
            promoPrice: 4,
            discount: 4,
            rateCode: 'WST_DIGI_4X8_1',
            benefitOverride: [
                'Unlimited access to thewest.com.au',
                'Digital version of Today’s Paper',
                'Daily puzzles',
                '19 WA regional titles',
            ],
        },
        {
            type: 'single-subscription',
            packagePath: 'offercheck/thewest?redirect=true&offerCode=BLKFRI2',
            heading: 'Everyday Digital + Weekend Papers',
            price: '$5/week',
            originalPrice: '$10 per week',
            billingCycle: 'Billed every four weeks',
            priceQualifier: '*for 8 weeks',
            packageType: 'digitalprint',
            ribbonTitle: 'On sale',
            ribbonOptions: 'cornerDesignTag',
            buttonStyle: 'solid-blue',
            offerCode: 'BLKFRI2',
            cancellationMessage: 'Cancel anytime. Min cost $40.00',
            weeklyPrice: 10,
            promoPrice: 5,
            discount: 5,
            rateCode: 'WST_PrSSDIG_5x8_1',
        },
    ],
    'vanishing-cousins': [],
    'top-50-schools': [],
    '50-off-afl-breach-screen': [],
    '50-off-breach-discount': [],
    'subs-campaign-eofy-weekend-digital': [],
    'business-pack': [],
    'sport-pack': [],
    'digital-only': [],
    Puzzles: [],
    'Puzzles-increase': [],
    'puzzles-swg-30-off': [],
    ePaper: [],
    'ePaper-price-increase': [],
    'default-breachwall-2024': [],
    'summer-of-cricket': [],
}

const rrmeSubscriptionPackages: Record<
    OfferGroupType,
    Record<string, SubscriptionPackageOptions[]>
> = {
    campaigns: rrmeCampaignPackages,
    breach: rrmeBreachPackages,
}

let cachedRrmeSubscriptionPackages: Record<
    string,
    Record<string, SubscriptionPackageOptions[]>
> = {}

export const getRrmeOfferPackages = (
    offerGroup: OfferGroupType,
): Record<string, SubscriptionPackageOptions[]> => {
    return (
        cachedRrmeSubscriptionPackages[offerGroup] ??
        rrmeSubscriptionPackages[offerGroup]
    )
}

/**
 * Loads subscription offers from the subscription offer API and caches them.
 */
export const loadRrmeOfferGroupFromApi = async (
    publicationId: string,
    log: Logger,
    offerGroup: OfferGroupType,
    variant?: string,
    config?: { subscriptionOfferApi?: string },
): Promise<Record<string, Record<string, SubscriptionPackageOptions[]>>> => {
    try {
        const offers = await fetchSubscriptionOffers(
            publicationId,
            log,
            offerGroup,
            variant,
            config,
        )

        cachedRrmeSubscriptionPackages[offerGroup] = offers

        storeOffersToLocalStorage(cachedRrmeSubscriptionPackages, log)

        log.info(
            { publicationId, cachedRrmeSubscriptionPackages, variant },
            'Successfully loaded subscription offers from API',
        )

        return cachedRrmeSubscriptionPackages
    } catch (error) {
        log.error(
            { error, publicationId, variant },
            'Failed to load subscription offers from API, attempting to load from localStorage or falling back to static data',
        )

        cachedRrmeSubscriptionPackages = tryAndGetOffersFromLocalStorage(
            publicationId,
            log,
            variant,
        )

        return cachedRrmeSubscriptionPackages
    }
}

function storeOffersToLocalStorage(
    offers: Record<string, Record<string, SubscriptionPackageOptions[]>>,
    log: Logger,
) {
    try {
        if (window.localStorage) {
            window.localStorage.setItem(
                'cachedRrmeSubscriptionPackages',
                JSON.stringify(offers),
            )
        }
    } catch (e) {
        log.warn(
            { error: e },
            'Failed to store subscription offers to localStorage',
        )
    }
}

function tryAndGetOffersFromLocalStorage(
    publicationId: string,
    log: Logger,
    variant?: string,
): Record<string, Record<string, SubscriptionPackageOptions[]>> {
    try {
        if (window.localStorage) {
            const localStorageCachedBreachPackages =
                window.localStorage.getItem('cachedRrmeSubscriptionPackages')

            if (localStorageCachedBreachPackages) {
                try {
                    const parsedOffers = JSON.parse(
                        localStorageCachedBreachPackages,
                    ) as Record<
                        string,
                        Record<string, SubscriptionPackageOptions[]>
                    >

                    log.info(
                        { publicationId, variant },
                        'Loaded subscription offers from localStorage',
                    )
                    return parsedOffers
                } catch (e) {
                    log.error(
                        { error: e, publicationId, variant },
                        'Failed to parse subscription offers from localStorage, falling back to static data',
                    )
                }
            }
        }
    } catch (e) {
        log.error(
            { error: e, publicationId, variant },
            'Failed to access localStorage, falling back to static data',
        )
    }
    return rrmeSubscriptionPackages
}
